/* eslint-disable jsx-a11y/label-has-associated-control */
import { Button, Grid, MenuItem, Select, TextField } from '@material-ui/core';
import GooglePlacesAutocomplete from '@orientaction/components/PlacesAutocomplete';
import { IAddress } from '@orientaction/components/PlacesAutocomplete/types';
import { useAlert } from '@orientaction/hooks';
import { updateUserInfoInLS } from '@orientaction/utils';
import { pick } from 'lodash';
import moment from 'moment';
import { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { apiServiceNative } from '../../utils/fetchNative';
import MaterialPhoneInput from '../MaterialPhoneInput';
import style from './style';
import { isValidPhoneNumber } from 'libphonenumber-js';

const FormRecrutementUser = (props: any) => {
  const classes = style();
  const { user, closeDrawer, getUser, idEbook } = props;
  const {
    control,
    formState: { errors, isValid },
    handleSubmit,
  } = useForm<any>({
    mode: 'onChange',
  });
  const alert = useAlert();
  const history = useHistory();

  const onSubmitHandler = async (data: any) => {
    try {
      const response = await apiServiceNative.put(`/api/users/${user.id}`, {
        ...data,
        town: placeValue,
      });
      if (response?.id) {
        updateUserInfoInLS(
          pick(response, [
            'town',
            'postal_code',
            'dayOfBirth',
            'gender',
            'streetName',
            'streetNumber',
            'phone',
            'yearExperiences',
            'poste',
            'noticeDeparture',
            'diploma',
          ])
        );
        closeDrawer();
        if (idEbook) {
          history.push(`/ebook-recrutement/${idEbook}/${false}/1`);
        }
        if (getUser) {
          getUser();
        }
      }
    } catch (e) {
      alert.setOpenAlert(true, 'Une erreur est survenue, merci de réessayer plus tard', 'error');
    }
  };
  const [placeValue, setPlaceValue] = useState(user?.town);
  const onPlaceChange = (address?: IAddress) => {
    if (address) {
      const { addressCity } = address;
      setPlaceValue(addressCity);
    } else {
      setPlaceValue('');
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmitHandler)}>
        <Grid container={true} spacing={2}>
          <Grid item={true} md={6} xs={12}>
            <Controller
              name="gender"
              control={control}
              defaultValue={user?.gender}
              rules={{
                required: 'Champ obligatoire',
              }}
              render={({ field }) => {
                return (
                  <>
                    <h5 className={classes.labelText}>Genre</h5>
                    <Select
                      {...field}
                      variant="outlined"
                      placeholder="Genre"
                      className={classes.formControlSelect}
                      data-cy="form-gender">
                      <MenuItem value="homme" data-cy="form-gender-homme">
                        Homme
                      </MenuItem>
                      <MenuItem value="femme" data-cy="form-gender-femme">
                        Femme
                      </MenuItem>
                      <MenuItem value="Non binaire">Non binaire</MenuItem>
                    </Select>
                    {errors?.gender?.message && (
                      <span className={classes.errorField}>{(errors as any).gender.message}</span>
                    )}
                  </>
                );
              }}
            />
          </Grid>
          <Grid item={true} md={6} xs={12}>
            <Controller
              name="dayOfBirth"
              control={control}
              defaultValue={user.dayOfBirth ? moment(user.dayOfBirth).format('YYYY-MM-DD') : ''}
              rules={{
                required: 'Champ obligatoire',
              }}
              render={({ field }) => (
                <>
                  <label htmlFor="dayOfBirth">
                    <h5 className={classes.labelText}>Anniversaire</h5>
                  </label>
                  <TextField
                    placeholder="dayOfBirth"
                    {...field}
                    type="date"
                    className={classes.input}
                    variant="outlined"
                  />
                  {errors?.dayOfBirth?.message && (
                    <span className={classes.errorField}>{(errors as any).dayOfBirth.message}</span>
                  )}
                </>
              )}
            />
          </Grid>
          <Grid item={true} lg={12} md={12} sm={12} xs={12}>
            <Controller
              name="diploma"
              control={control}
              defaultValue={user?.diploma}
              rules={{
                required: 'Champ obligatoire',
              }}
              render={({ field }) => {
                return (
                  <>
                    <h5 className={classes.labelText}>Diplôme</h5>
                    <Select
                      {...field}
                      variant="outlined"
                      placeholder="diplome"
                      className={classes.formControlSelect}
                      data-cy="form-diploma">
                      <MenuItem value="Aucun diplôme">Aucun diplôme</MenuItem>
                      <MenuItem value="CAP/BEP">CAP/BEP</MenuItem>
                      <MenuItem value="BAC">BAC</MenuItem>
                      <MenuItem value="BAC+1">BAC+1</MenuItem>
                      <MenuItem value="BAC+2">BAC+2</MenuItem>
                      <MenuItem value="BAC+3">BAC+3</MenuItem>
                      <MenuItem value="BAC+4" data-cy="form-diploma-bac-4">
                        BAC+4
                      </MenuItem>
                      <MenuItem value="BAC+5">BAC+5</MenuItem>
                      <MenuItem value="BAC+6">BAC+6</MenuItem>
                      <MenuItem value="BAC+7">BAC+7</MenuItem>
                      <MenuItem value="BAC+8">BAC+8</MenuItem>
                    </Select>
                    {errors?.diploma?.message && (
                      <span className={classes.errorField}>{(errors as any).diploma.message}</span>
                    )}
                  </>
                );
              }}
            />
          </Grid>
          <Grid item={true} lg={6} md={6} sm={12} xs={12}>
            <Controller
              name="streetNumber"
              control={control}
              defaultValue={user?.streetNumber}
              rules={{
                required: 'Champ obligatoire',
              }}
              render={({ field }) => {
                return (
                  <label htmlFor="streetNumber">
                    <h5 className={classes.labelText}> N° de la voie</h5>
                    <TextField
                      {...field}
                      type="text"
                      placeholder="6"
                      className={classes.input}
                      variant="outlined"
                    />
                    {errors?.streetNumber?.message && (
                      <span className={classes.errorField}>
                        {(errors as any).streetNumber.message}
                      </span>
                    )}
                  </label>
                );
              }}
            />
          </Grid>
          <Grid item={true} lg={6} md={6} sm={12} xs={12}>
            <Controller
              name="streetName"
              control={control}
              defaultValue={user?.streetName}
              rules={{
                required: 'Champ obligatoire',
              }}
              render={({ field }) => {
                return (
                  <label htmlFor="streetName">
                    <h5 className={classes.labelText}> Nom de la voie</h5>
                    <TextField
                      placeholder=""
                      {...field}
                      type="text"
                      className={classes.input}
                      variant="outlined"
                    />
                    {errors?.streetName?.message && (
                      <span className={classes.errorField}>
                        {(errors as any).streetName.message}
                      </span>
                    )}
                  </label>
                );
              }}
            />
          </Grid>
          <Grid item={true} lg={6} md={6} sm={12} xs={12}>
            <Controller
              name="postal_code"
              control={control}
              defaultValue={user?.postal_code}
              rules={{
                required: 'Champ obligatoire',
              }}
              render={({ field }) => {
                return (
                  <label htmlFor="postal_code">
                    <h5 className={classes.labelText}> Code postal</h5>
                    <TextField
                      placeholder="75000"
                      {...field}
                      type="number"
                      className={classes.input}
                      variant="outlined"
                    />
                    {errors?.postal_code?.message && (
                      <span className={classes.errorField}>
                        {(errors as any).postal_code.message}
                      </span>
                    )}
                  </label>
                );
              }}
            />
          </Grid>
          <Grid item={true} lg={6} md={6} sm={12} xs={12}>
            <label htmlFor="town">
              <h5 className={classes.labelText}>
                {' '}
                <strong>Ville</strong>
              </h5>
              <GooglePlacesAutocomplete
                inputProps={{
                  placeholder: 'Paris (75)',
                  onKeyDown: e => {
                    if (e.key === 'Backspace') {
                      setPlaceValue('');
                    }
                  },
                  onClick: e => setPlaceValue(''),
                }}
                onDone={onPlaceChange}
                inputValue={placeValue || ''}
                setInputValue={newValue => setPlaceValue(newValue)}
                label="Enter your location"
                apiKey={process.env.REACT_APP_GOOGLE_API_KEY}
              />
              {errors?.town?.message && (
                <span className={classes.errorField}>{(errors as any)?.town.message}</span>
              )}
            </label>
          </Grid>
          <Grid item={true} lg={12} md={12} sm={12} xs={12}>
            <Controller
              name="phone"
              control={control}
              defaultValue={user?.phone}
              rules={{
                required: 'Champ obligatoire',
                validate: {
                  isValid: value =>
                    isValidPhoneNumber(value || '') || 'Le format du numéro est invalide',
                },
                minLength: {
                  value: 3,
                  message: 'Le numéro est trop court',
                },
              }}
              render={({ field, fieldState }) => (
                <>
                  <label htmlFor="phone">
                    <h5 className={classes.labelText}> Téléphone</h5>
                  </label>
                  <MaterialPhoneInput
                    style={{ border: '1px solid #E3E8F0', height: 30, backgroundColor: 'white' }}
                    value={field.value}
                    onChange={field.onChange}
                    onCountryChange={field.onBlur}
                    error={fieldState.invalid ? "Le numéro n'est pas au bon format" : false}
                  />
                </>
              )}
            />
          </Grid>
          <Grid item={true} lg={12} md={12} sm={12} xs={12}>
            <Controller
              name="yearExperiences"
              control={control}
              defaultValue={user?.yearExperiences}
              rules={{
                required: 'Champ obligatoire',
              }}
              render={({ field }) => {
                return (
                  <>
                    <h5 className={classes.labelText}>
                      <strong>
                        {`Combien d'années d'expérience avez-vous sur votre poste actuel ?`}
                      </strong>
                    </h5>
                    <Select
                      {...field}
                      variant="outlined"
                      placeholder="diplome"
                      className={classes.formControlSelect}
                      data-cy="form-diploma">
                      <MenuItem value="Débutant">Débutant</MenuItem>
                      <MenuItem value="1 an">1 an</MenuItem>
                      <MenuItem value="2 ans">2 ans</MenuItem>
                      <MenuItem value="3 ans">3 ans</MenuItem>
                      <MenuItem value="4 ans">4 ans</MenuItem>
                      <MenuItem value="5 ans">5 ans</MenuItem>
                      <MenuItem value="6 ans">6 ans</MenuItem>
                      <MenuItem value="7 ans">7 ans</MenuItem>
                      <MenuItem value="8 ans">8 ans</MenuItem>
                      <MenuItem value="9 ans">9 ans</MenuItem>
                      <MenuItem value="10 ans">10 ans</MenuItem>
                      <MenuItem value="11 ans">+ de 10 ans</MenuItem>
                    </Select>
                    {errors?.yearExperiences?.message && (
                      <span className={classes.errorField}>
                        {(errors as any).yearExperiences.message}
                      </span>
                    )}
                  </>
                );
              }}
            />
          </Grid>
          <Grid item={true} lg={12} md={12} sm={12} xs={12}>
            <Controller
              name="poste"
              control={control}
              defaultValue={user?.poste}
              rules={{
                required: 'Champ obligatoire',
              }}
              render={({ field }) => {
                return (
                  <>
                    <h5 className={classes.labelText}>Quelle est votre situation actuelle ?</h5>
                    <Select
                      {...field}
                      variant="outlined"
                      placeholder="diplome"
                      className={classes.formControlSelect}
                      data-cy="form-diploma">
                      <MenuItem value="en poste">En poste</MenuItem>
                      <MenuItem value="fin de contrat">
                        En poste, mais fin de contrat bientôt
                      </MenuItem>
                      <MenuItem value="sans emploi">Sans emploi</MenuItem>
                    </Select>
                    {errors?.poste?.message && (
                      <span className={classes.errorField}>{(errors as any).poste.message}</span>
                    )}
                  </>
                );
              }}
            />
          </Grid>
          <Grid item={true} lg={12} md={12} sm={12} xs={12}>
            <Controller
              name="noticeDeparture"
              control={control}
              defaultValue={user?.noticeDeparture}
              rules={{
                required: 'Champ obligatoire',
              }}
              render={({ field }) => {
                return (
                  <>
                    <h5 className={classes.labelText}>
                      Combien avez-vous de mois de préavis pour votre poste actuel ?
                    </h5>
                    <Select
                      {...field}
                      variant="outlined"
                      className={classes.formControlSelect}
                      data-cy="form-diploma">
                      <MenuItem value="dès que possible">Dès que possible</MenuItem>
                      <MenuItem value="1 mois">1 mois</MenuItem>
                      <MenuItem value="2 mois">2 mois</MenuItem>
                      <MenuItem value="3 mois">3 mois</MenuItem>
                      <MenuItem value="4 mois">4 mois</MenuItem>
                      <MenuItem value="5 mois">5 mois</MenuItem>
                      <MenuItem value="6 mois">6 mois</MenuItem>
                      <MenuItem value="7 mois">7 mois</MenuItem>
                      <MenuItem value="8 mois">8 mois</MenuItem>
                      <MenuItem value="9 mois">9 mois</MenuItem>
                      <MenuItem value="10 mois">10 mois</MenuItem>
                      <MenuItem value="11 mois">11 mois</MenuItem>
                      <MenuItem value="12 mois">12 mois</MenuItem>
                    </Select>
                    {errors?.noticeDeparture?.message && (
                      <span className={classes.errorField}>
                        {(errors as any).noticeDeparture.message}
                      </span>
                    )}
                  </>
                );
              }}
            />
          </Grid>
        </Grid>
        <Button
          variant="contained"
          color="primary"
          disabled={!isValid || !placeValue}
          type="submit"
          className={classes.btnConfirm}>
          Confirmer
        </Button>
      </form>
    </>
  );
};

export default FormRecrutementUser;
